<template>
	<div id="container" ref="slideContainer" class="vld-parent">
		<transition :name="mainTransitionName" mode="out-in">
			<div id="videoContainer" v-show="isVideoVisible">
                <!-- 기본 이미지 슬라이드 영역 -->
                <image-slider 
                    v-if="slideFiles.length"
                    :slideFiles="slideFiles"
                    :last="last"
                    :recent="recent"
                    :time="time"
                    :isAllPages="isAllPages"
                    :isScroll="isScroll"
                    :isTimeline="isTimeline"
                    @updateProgress="updateProgress"
                    @updateEndedLesson="updateEndedLesson"
                    id="wrap-slide-contents"
                ></image-slider>
				<!-- 이미지 슬라이드 세로 전체 페이지 영역  -->
				<div id="verticalList" ref="verticalList" class="d-portrait-none" v-show="isAllPages">
					<ul>
						<li v-for="(item, index) in slideFiles" :key="index" :data-id="index" :class="currentSlide-1 === index ? 'active' : ''" ref="verticalSlide">
							<img :src="item" alt="Image"/>
						</li>
					</ul>
				</div>

                <div class="d-landscape-block d-portrait-none lesson-name t-body4">
                    {{lessonName}}
				</div>
				<div id="imageInfo" class="d-landscape-none">
					<span class="typography--b5">{{ currentSlide }} / </span>  
                    <span class="color-secondary">{{ slideFiles.length }}</span>
				</div>
				<button @click="moveLearnView()" id="btnClose"></button>
				<button @click="moveQuestion()" id="btnQnA" class="d-landscape-none"></button>
				<button @click="onScrollClick()" id="btnScroll" class="d-landscape-none"><span>
                    {{$t('1116')}}
                    <!-- Scroll -->
                </span></button>
				<button @click="onScrollClick()" id="btnPaging" class="d-landscape-none"><span>
                    {{$t('1117')}}
                    <!-- Paging -->
                </span></button>
                <span class="video-watermark dark">{{ personalInfo?personalInfo.userId:'' }}</span>
                <span class="video-watermark light">{{ personalInfo?personalInfo.userId:'' }}</span>
			</div>
		</transition>
		
        <!-- 버튼 영역 -->
		<transition :name="mainTransitionName" mode="out-in">
			<div v-show="isVideoVisible" class="d-portrait-none" id="videoButtonsContainer">
				<button @click="onToggleAllPages()" class="typography--b3">
                    {{$t('1052')}}
                    <!-- All Pages -->
                </button>
				<button @click="moveQuestion()" class="typography--b3">
                    {{$t('1053')}}
                    <!-- Ask a question -->
                </button>
				<button @click="onTogglePlaylist()" class="typography--b3">
                    {{$t('1054')}}
                    <!-- Lectures -->
                </button>
			</div>
		</transition>

        

        <!-- 진도율 / 좋아요 / 북마크 영역 -->
		<transition :name="mainTransitionName" mode="out-in">
			<div v-show="isVideoVisible" id="mainContainer" class="d-landscape-none">
				<div id="videoDetails">
					<span class="typography--s4 d-block mt-3">{{lessonName}}</span>
					<span class="typography--b7 d-block mt-2 color-secondary">{{rate}} %</span>
				</div>

				<like-and-bookmark
                    :likesCount="likesCount"
                    :clippingCount="clippingCount"
                    :likes="likes"
                    :clipping="clipping"
                    @updateLikesCount="updateLikesCount"
                    @updateBookmarkCount="updateBookmarkCount"
                ></like-and-bookmark>
			</div>
		</transition>

        <div id="resizeContainer">
			<div></div>
		</div>

        <!-- 퀴즈 영역 -->
        <transition name="slide" mode="out-in">
			<timeline-quiz-detail 
                @closeQuizDetail="closeQuizDetail()" 
                v-if="isQuizVisible" 
                :currentTimelineContents="currentTimelineContents"
            />
		</transition>


		<!-- 차시 목록 영역 -->
        <transition :name="mainTransitionName" mode="out-in">
			<div v-show="isLecturesVisible" id="playlistContainer">
				<div class="title">
					<button @click="onTogglePlaylist()" id="btnPlaylistClose"></button>
                    <span class="typography--s4 text-center" :class="{'typography--b4': !showLectureList, 'text-left': !showLectureList}">
                        {{showLectureList ? `${$t('1086')}` : `${$t('1045')}: ${nextLessonName}`}}
                    </span>
                    <i class="material-icons" id="btnPlaylistToggle" @click="onTogglePlaylist()">expand_less</i>
					<div class="clearfix"></div>
				</div>
				<div class="lectures-list">
					<lessons-list :lessonsList="lessonsList" :currentProgressionId="currentProgressionId"></lessons-list>
				</div>
			</div>
		</transition>

        

        <!-- 페이징 노출 아이콘 -->
		<div id="pagingIcon">
			<div>
				<img src="../../assets/check-big.svg" alt="Paging"/>
				<span class="typography--b4">
                    {{$t('1117')}}
                    <!-- Paging -->
                </span>
			</div>
		</div>

        <!-- 스크롤 노출 아이콘 -->
		<div id="scrollIcon">
			<div>
				<img src="../../assets/check-big.svg" alt="Scroll"/>
				<span class="typography--b4">
                    {{$t('1116')}}
                    <!-- Scroll -->
                </span>
			</div>
		</div>

        <!-- 퀴즈 팝업 -->
        <transition name="bounce">
            <timeline-quiz-pop :currentTimelineContents="currentTimelineContents" v-if="isTimelineQuiz"
                @closeQuizPop="closeQuizPop()"
                @openQuizDetail="openQuizDetail()"
            />
        </transition>

        <!-- 리소스 팝업 -->
        <transition name="bounce">
            <timeline-resource-pop :currentTimelineContents="currentTimelineContents" v-if="isTimelineResource"
                @closeResource="closeResource()"
                @openResource="openResource()"
            />
        </transition>

        <pop-next-lesson :nextLesson="nextLesson" v-if="endedLesson && nextLesson"
            @moveLearnView="moveLearnView"
        ></pop-next-lesson>
        
        <!-- {{lessonData}} -->
	</div>
</template>
<script>
/**
 * 나의 학습 차시 학습창 - 슬라이드 이미지 컨텐츠 컴포넌트(my learning lesson study - slide image content component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import learnApi from '@/api/learnApi.js'
import ImageSlider from './slider/ImageSlider.vue'
import {slideTypeMixins} from '../../mixins/slideType.js'
import LessonsList from './LessonsList.vue'

import TimelineQuizPop from "./TimelineQuizPop.vue";
import TimelineQuizDetail from "./TimelineQuizDetail.vue";
import TimelineResourcePop from "./TimelineResourcePop.vue";
import LikeAndBookmark from "./LikeAndBookmark.vue";
import PopNextLesson from "./PopNextLesson.vue";
import { captureApiError } from "@/utils/sentryApiHandler.js"
import { updateLearnProgression } from "@/utils/learnProgressionUtil.js";

export default {
    data() {
        return {
            slideFiles: [],
            lessonData: null,
            lessonName: '',
            lessonsList: [],
            nextLessonName: '',            
            currentProgressionId: '',
            rate: 0,
            last: 0,
            recent: 0,
            time: 0,
            currentSlide: 0,
            showLectureList: false,

            //타임라인 관련 데이터(timeline data)
            isTimelineQuiz: false,
            isTimelineResource: false,
            timelineContents: [],
            currentTimelineContents: null,


            // 북마크 좋아요 관려 데이터(like & bookmark data)
            isLiked: false,
            isBookmarked: false,
            likes: false,
            likesCount: 0,
            clipping: false,
            clippingCount: 0,

            isAllPages: false,
            isScroll: false,
            isTimeline: false,

            endedLesson: false,
            personalInfo: null,
        }
    },

    components: {
        'image-slider': ImageSlider,
        'lessons-list' : LessonsList,

        'timeline-quiz-pop': TimelineQuizPop,
        'timeline-quiz-detail': TimelineQuizDetail,
        'timeline-resource-pop': TimelineResourcePop,
        'pop-next-lesson' : PopNextLesson,
        'like-and-bookmark': LikeAndBookmark
    },

    mixins: [slideTypeMixins],

    computed: {
        swiper() {
            return this.$refs.previewSwiper.swiper
        },
    },
    mounted() {
        this.$showLoading(this.$refs.slideContainer)
        let params = this.setParams()
        let responseData = null
                
        //차시 컨텐츠 정보 API 호출(get lesson contents data)
        learnApi.learnLessonContents(params).then((response) => {
            responseData = response.data.data
            this.lessonData = responseData
            this.lessonName = this.lessonData.lessonName
            this.rate = this.lessonData.rate
            this.slideFiles = this.lessonData.slide.files.filter((url) =>!url.includes("__MACOSX") )
            this.last = this.lessonData.last
            this.recent = this.lessonData.recent
            this.currentProgressionId = this.lessonData.progressionId
            this.time = this.lessonData.slide.time

            this.likes = this.lessonData.likes
            this.likesCount = this.lessonData.likesCount
            this.clipping = this.lessonData.clipping
            this.clippingCount = this.lessonData.clippingCount            
           
            this.fetchLectureList()
            
        }).catch((err) => {
            captureApiError({ err, frontRoute: this.$route, frontData: this.$data });
        })

        learnApi.getMemberInfo().then((response) => {
            this.personalInfo = response.data.data;
        });
        
        // 타임라인 컨텐츠 정보 API 호출(get timeline data)
        learnApi.learnLessonTimelinecontents(params).then((response) => {
            responseData = response.data.data
            // console.log('learnLessonTimelinecontents', responseData)
            this.timelineContents = responseData
        }).catch((err) => {
            captureApiError({ err, frontRoute: this.$route, frontData: this.$data });
        })
    },
    methods: {
        
        updateEndedLesson(value) {
            this.endedLesson = value
        },
        
        // 진도저장 API 호출(update progress)
        updateProgress(currentIndex) {

            if (currentIndex) {
                this.currentSlide = currentIndex + 1
            }else {
                this.currentSlide = 1
            }

            let params = this.setParams()
            let responseData = null

            // 마지막 학습이 없거나, 마지막 학습보다 클때 진도 업데이트
            // Progress update when there is no last lesson or greater than the last lesson
            if (!this.last || this.last <= this.currentSlide) {
                updateLearnProgression({ params, vueThis: this }).then((response) => {
                    if (response) {
                        responseData = response.data.data
                        this.rate = responseData.rate
                        this.last = responseData.last
                    }
                }).catch((err) => {
                    captureApiError({ err, frontRoute: this.$route, frontData: this.$data });
                })
            }

            if (!this.isPortrait) {
                this.moveScrollVerticalList(currentIndex)
            }


            // Timeline logic
            let findTimelineContents = _.find(this.timelineContents, (content) => {
                return parseInt(content.position) === this.currentSlide
            })
            
            let isChange = false
            if (findTimelineContents) {
                isChange = true
                this.currentTimelineContents = findTimelineContents
            }
            
            if (isChange) { 
                // 타임라인 컨텐츠가 있으면(With timeline content)
                if (this.currentTimelineContents.type.value === 'QUIZ') {   
                    // 퀴즈(quiz)
                    this.isTimelineQuiz = true
                    this.isTimelineResource = false
                }else { //파일(resource)
                    this.isTimelineQuiz = false
                    this.closeQuizDetail()
                    this.isTimelineResource = true
                }
            }

            
        },

        // API 파라미터 설정(set parameter)
        setParams() {
            let params = {
                total: this.slideFiles.length,
                current: this.currentSlide,
                learnId: this.$route.params.learnId,
                progressionId: this.$route.params.progressionId
            }
            return params
        },

        // update likes count
        updateLikesCount(data) {
            this.likes = data.likes
            this.likesCount = data.likesCount
        },

        // update bookmark count
        updateBookmarkCount(data) {
            this.clipping = data.clipping
            this.clippingCount = data.clippingCount
        },


        // 학습 목록 API 호출(get lesson list)
        fetchLectureList() {
            let responseData = null
            let params = this.setParams()

            //차시 정보
            learnApi.learnViewCourses(params).then((response) => {
                // 과정의 차시 정보만 병합
                // Merging only lesson data from the course
                _.each(response.data.data, (course) => {
                    this.lessonsList = this.lessonsList.concat(course.lessons)
                })
                
                // 다음 차시명 설정(set next lesson)
                let currentLessonIndex = _.findIndex(this.lessonsList,(lesson) => { return lesson.progressionId === this.currentProgressionId})
                let nextLessonIndex = this.lessonsList.length > 1 && this.lessonsList.length > currentLessonIndex ? currentLessonIndex += 1 : -1
                if (nextLessonIndex) {
                    this.nextLesson = this.lessonsList[nextLessonIndex]
                    if (this.nextLesson) this.nextLessonName = this.lessonsList[nextLessonIndex].name;
                }
                
            }).catch((err) => {
                captureApiError({ err, frontRoute: this.$route, frontData: this.$data });
            })
        },

        // 가로모드 전체 보기 스크롤 이동(Landscape mode move scroll)
        moveScrollVerticalList(index) {
            let element = this.$refs.verticalSlide[index]
            let options = {
                container: this.$refs.verticalList,
                easing: 'ease-in'
            }
            this.$scrollTo(element, 500, options)
        },

        // //나의 학습 상세로 이동(Go to my learning details)
        // moveLearnView() {
        //     this.$router.push({
        //         name: 'LearnView', 
        //         params: {learnId: this.$route.params.learnId},
        //         query: this.$route.query
        //     })
        // },
        moveLearnView() {
            let goBackBookMarkLessson = localStorage.getItem('videoBookMarkLesson')
            let goBackLikeLessson = localStorage.getItem('videoLikeLesson')
            if(goBackBookMarkLessson == 'setVideoBookMarkLesson'){
            localStorage.removeItem('videoBookMarkLesson');
            this.$router.push({
            name: 'BookMarkedLesson' 
            })
            }else if(goBackLikeLessson=='setVideoLikeLesson'){
            localStorage.removeItem('videoLikeLesson');
            this.$router.push({
            name: 'LikedLesson' 
            })
            }else{
            this.$router.push({
            name: 'LearnView', 
            params: {learnId: this.$route.params.learnId},
            query: this.$route.query
            })
            }
        },
        // 타임라인 퀴즈 상세 보기(View detailed timeline quiz)
        async openQuizDetail() {
            await this.closeResource()
            const elementBody = document.querySelector('body')
            elementBody.classList.add('quiz-overlay')
            this.mainTransitionName = 'slide-up'
            this.isTimelineQuiz = false
            this.isQuizVisible = true
            this.isTimeline = true
            
        },

        // 타임라인 퀴즈 상세 닫기(close detailed timeline quiz)
        closeQuizDetail() {
            return new Promise(resolve => {
                const elementBody = document.querySelector('body')
                this.mainTransitionName = 'slide-up'
                this.isQuizVisible = false

                setTimeout(() => {
                    elementBody.classList.remove('quiz-overlay')
                    this.isTimeline = false
                    resolve()
                }, 500)
            })
            
        },

        // 타임라인 퀴즈 상세 보기(View detailed timeline resource)
        async openResource() {
            await this.closeQuizDetail()
            const elementBody = document.querySelector('body')
            elementBody.classList.add('quiz-overlay')
            this.mainTransitionName = 'slide-up'
            this.isTimelineResource = true 
            this.isTimeline = true
        },

        // 타임라인 퀴즈 상세 닫기(close detailed timeline resource)
        closeResource() {
            return new Promise(resolve => {
                const elementBody = document.querySelector('body')
                this.mainTransitionName = 'slide-up'
                this.isTimelineResource = false
                                
                setTimeout(() => {
                    elementBody.classList.remove('quiz-overlay')
                    this.isTimeline = false
                    resolve()
                }, 500)
                
            })
        },
        
        async onToggleQuiz() {
            if (this.isTimelineResource) {
                this.isTimelineResource = false
                await this.onToggleResource()
            }

            return new Promise(resolve => {
                const elementBody = document.querySelector('body')
                this.isTimelineQuiz = false

                if (!elementBody.classList.contains('quiz-overlay')) {
                    this.mainTransitionName = 'slide-up'
                    elementBody.classList.add('quiz-overlay')
                    this.isQuizVisible = true
                    this.isTimeline = true
                    resolve()
 
                } else {
                    this.mainTransitionName = 'slide-up'
                    this.isQuizVisible = false
                    
                    setTimeout(() => {
                        elementBody.classList.remove('quiz-overlay')
                        this.isTimeline = false
                        resolve() 
                    }, 500)
                }
            })
        },

        async onToggleResource() {
            if (this.isQuizVisible) {
                this.isTimelineQuiz = false
                this.isQuizVisible = false
                await this.onToggleQuiz()
            }

            return new Promise(resolve => {
                const elementBody = document.querySelector('body')            
                console.log('onToggleResource')
                
                if (!elementBody.classList.contains('quiz-overlay')) {
                    this.mainTransitionName = 'slide-up'
                    if (this.isPortrait) {
                        //this.isVideoVisible = false
                        //this.isControlsVisible = false
                    }
                    elementBody.classList.add('quiz-overlay')
                    this.isResourceVisible = true
                    resolve()
                    
                } else {
                    this.mainTransitionName = 'slide-up'
                    //this.isVideoVisible = true
                    //this.isControlsVisible = true
                    this.isResourceVisible = false
                    setTimeout(() => {
                        elementBody.classList.remove('quiz-overlay');
                        resolve()
                    }, 500);
                }
            })
            
        },

        // 타임라인 퀴즈 팝업 닫기(Close the timeline quiz popup)
        closeQuizPop() {
            this.isTimelineQuiz = false
            this.isTimeline = false
        },

        // 질문하기로 이동(Go to Ask a Question)
        moveQuestion() {
            this.$router.push({
                name: 'LessonViewQuestion',
                query: this.$route.query
            })
        }


    }
}
</script>
<style scoped src="../../css/slide.css"></style>
<style scoped>
#playlistContainer.show{
    z-index: 999;
}
span.video-watermark {
    position: absolute;
    /* left: 20px; */
    font-size: 12px;
    transform: rotate(-45deg);
    opacity: 0.25;
    cursor: none;
    z-index: 999;
}
span.video-watermark.light {
    color: #FFF;
    top: 50%;
    left: 40%;
    transform: translate(-40%,-50%) rotate(-45deg);
}
span.video-watermark.dark {
    color: #000000;
    top: 50%;
    left: 51%;
    transform: translate(-51%,-50%) rotate(-45deg);
}
@media (min-width: 480px) {
    span.video-watermark.light {
    left: 45%;
    transform: translateX(-45%) rotate(-45deg);
}
}
</style>

